import { KnownSource, Ctx } from '../core/types'
import { normalize } from '../core/utils'
import { defaultMappers } from '../config/defaultMappers'
import { partnerRulesMap } from '../config/partnerRules'
import { ApplicationFormAnswers } from '../../../components/ApplicationForm/ApplicationFormContext'


export const mapFormlessApp = (
    answers: ApplicationFormAnswers,
    source: KnownSource
): ApplicationFormAnswers => {
    const ctx: Ctx = { source: normalize(source), answers }
    const rules = partnerRulesMap[ctx.source] ?? {}

    const mapper = <K extends keyof typeof defaultMappers>(key: K) =>
        rules[key] ?? defaultMappers[key]

    return {
        addressHistory: mapper('addressHistory')(answers.addressHistory, ctx),
        contactNumber: mapper('contactNumber')(answers.contactNumber, ctx),
        drivingLicence: mapper('drivingLicence')(answers.drivingLicence, ctx),
        emailAddress: mapper('emailAddress')(answers.emailAddress, ctx),
        employmentHistory: mapper('employmentHistory')(answers.employmentHistory, ctx),
        loanAmount: mapper('loanAmount')(answers.loanAmount, ctx),
        maritalStatus: mapper('maritalStatus')(answers.maritalStatus, ctx),
        monthlyIncome: mapper('monthlyIncome')(answers.monthlyIncome, ctx),
        personalDetails: mapper('personalDetails')(answers.personalDetails, ctx),
        title: mapper('title')(answers.title, ctx),
        vehicleType: mapper('vehicleType')(answers.vehicleType, ctx)
    }
}
